<template>
  <main class="mt-5">
    <div class="card mt-3">
      <div class="card-header border-0">
        <h5 class="card-title font-bold">
          آپلود اکسل سطح مشتری‌ها
        </h5>
      </div>

      <div class="card-body">
        <Loading v-if="loading" />
        <b-form v-else @submit.prevent="submitHandler">
          <b-form-group label="انتخاب فایل اکسل">
            <b-form-file
              v-model="file"
              accept=".xlsx,.xls"
              placeholder="فایل اکسل را انتخاب کنید..."
              browse-text="انتخاب فایل"
            />
          </b-form-group>
          <b-button
            type="submit"
            variant="primary"
            :disabled="disabled || !file"
          >
            آپلود فایل
          </b-button>
        </b-form>
      </div>
    </div>

    <div class="card mt-3">
      <div class="card-header border-0">
        <h5 class="card-title font-bold">
          لیست اکسل‌های آپلود شده
        </h5>
      </div>

      <div class="card-body">
        <Loading v-if="listLoading" />
        <template v-else>
          <b-table
            :items="uploads"
            :fields="fields"
            show-empty
            empty-text="هنوز فایلی آپلود نشده است"
            responsive
            hover
            striped
            class="text-center"
          >
            <template #cell(index)="data">
              {{ (pagination.from || 1) + data.id }}
            </template>
            <template #cell(created_at)="data">
              {{ formatDate(data.item.created_at) }}
            </template>
            <template #cell(file)="data">
              <a
                v-if="data.item.file"
                :href="data.item.file"
                target="_blank"
                rel="noopener"
              >
                دانلود فایل
              </a>
              <span v-else>-</span>
            </template>
          </b-table>

          <b-pagination
            v-if="pagination.last_page > 1"
            v-model="currentPage"
            :total-rows="pagination.total"
            :per-page="pagination.per_page"
            align="center"
            class="mt-3"
            @change="fetchImports"
          />
        </template>
      </div>
    </div>
  </main>
</template>

<script>
import {
  BFormGroup,
  BFormFile,
  BButton,
  BForm,
  BTable,
  BBadge,
  BPagination,
} from "bootstrap-vue";

import Loading from "@@/core/components/shared/Loading/Loading";
import mixins from "@@/core/mixins/mixins";

export default {
  name: "CustomerLevelsImport",

  components: {
    BFormGroup,
    BFormFile,
    BForm,
    BButton,
    BTable,
    BBadge,
    BPagination,
    Loading,
  },

  mixins: [mixins],

  data() {
    return {
      loading: false,
      disabled: false,
      file: null,

      listLoading: false,
      uploads: [],
      pagination: {},
      currentPage: 1,
      fields: [
        { key: "id", label: "شناسه" },
        { key: "title", label: "نام فایل" },
        { key: "created_at", label: "تاریخ آپلود" },
        { key: "file", label: "فایل" },
      ],
    };
  },

  created() {
    this.fetchImports();
  },

  methods: {
    async fetchImports(page = 1) {
      try {
        this.listLoading = true;
        const response = await this.$axios.get(
          "admin/customers/import-levels",
          { params: { page } },
        );
        const uploads = response.data?.data?.uploads ?? {};

        this.uploads = uploads.data ?? [];
        this.pagination = uploads;
        this.currentPage = uploads.current_page ?? 1;
      } catch (errors) {
        const errorList = errors.response?.data?.errors ?? [];

        errorList.forEach((error) => {
          this.$notify({
            group: "error",
            text: error.reason,
            type: "error",
            duration: 15000,
          });
        });
      } finally {
        this.listLoading = false;
      }
    },

    formatDate(date) {
      if (!date) return "-";

      return new Date(date).toLocaleString("fa-IR");
    },

    async submitHandler() {
      if (!this.file) {
        this.$bvToast.toast("لطفا فایل اکسل را انتخاب کنید", {
          variant: "warning",
          solid: true,
        });

        return;
      }
      let formData = new FormData();

      formData.append("file", this.file);
      try {
        this.loading = true;
        this.disabled = true;
        const response = await this.$axios.post(
          "admin/customers/import-levels",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          },
        );

        this.$root.notify(response.data.message, "success");
        this.file = null;
        this.fetchImports();
      } catch (errors) {
        const errorList = errors.response?.data?.errors ?? [];

        errorList.forEach((error) => {
          this.$notify({
            group: "error",
            text: error.reason,
            type: "error",
            duration: 15000,
          });
        });
      } finally {
        this.loading = false;
        this.disabled = false;
      }
    },
  },
};
</script>

<style scoped>
.card-body {
  min-height: 200px;
}
</style>
